import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import './css/bootstrap.min.css';
import './css/style.css';

import Home from './components/Calculate';
import Contact from './components/Contact';
// import NotFound from './components/notfound';


const App = () =>{
  return(
    <Router>
      <div id="wrapper">
        <Switch>
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/" component={Home} />
        </Switch>
      </div>
    </Router>
  )
}

export default App;